import { FC, ForwardedRef } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { CornerImageProps } from "./types";
import Image from "next/image";
import { forwardRef } from "react";
import { translateClasses } from "./utils/translateClasses";

// Create a motion-compatible Image component
const MotionImage = motion(
  forwardRef(function MotionImage(
    {
      src,
      alt,
      width,
      height,
      className,
      ...props
    }: {
      src: string;
      alt: string;
      width: number;
      height: number;
      className: string;
    },
    ref: ForwardedRef<HTMLImageElement>
  ) {
    return (
      <Image
        ref={ref}
        src={src}
        alt={alt || ""}
        width={width || 500}
        height={height || 500}
        quality={75}
        priority={true}
        className={className}
        {...props}
      />
    );
  })
);

const CornerImage: FC<CornerImageProps> = ({
  mainImage,
  backgroundImage,
  variation = null,
  rounded = false,
  shadow = false,
}) => {
  return (
    <div className="relative h-full lg:max-w-[600px] w-full">
      {backgroundImage && (
        <MotionImage
          src={backgroundImage}
          alt="background"
          whileInView={
            variation && (translateClasses.animate[variation] as any)
          }
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false }}
          width={600}
          height={399}
          className={clsx([
            "absolute z-0 h-full transform",
            // variation && translateClasses[variation],
            rounded && "rounded-lg",
            shadow && "shadow-lg",
          ])}
        />
      )}

      {mainImage && (
        <Image
          src={mainImage}
          alt="main"
          width={600}
          height={399}
          quality={75}
          className={clsx([
            "relative z-10 w-full h-full object-cover",
            rounded && "rounded-lg",
            shadow && "shadow-lg",
          ])}
        />
      )}
    </div>
  );
};

export default CornerImage;
